export default __webpack_public_path__ + "static/media/24.dfab1d7d.mp3";